module.exports = __webpack_public_path__ + "static/media/id-icon.2dba2bc7.svg";